import { Input } from "@/components/ui/input";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { cn } from "@/lib/utils";

export default function ClientNavigation({
  view,
  setView,
  searchQuery,
  setSearchQuery,
}: {
  view?: string;
  setView?: (view: string) => void;
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
}) {
  return (
    <div className="flex flex-row gap-4">
      {view && (
        <ToggleGroup
          type="single"
          className="bg-black-950 h-[45px] w-[154px] gap-1 p-1.5"
        >
          <ToggleGroupItem
            value="grid"
            aria-label="Toggle bold"
            className={cn(
              "hover:text-black-950 flex cursor-pointer flex-row gap-1 !rounded-[4px] px-1.5 py-[2px] transition-all duration-200 hover:bg-white",
              view === "grid" && "text-black-950 bg-white",
            )}
            onClick={() => setView?.("grid")}
          >
            <div className="flex flex-row items-center gap-1">
              <i className="ri-layout-grid-line text-md leading-none font-light"></i>
              <h1 className="text-md font-medium">Grid</h1>
            </div>
          </ToggleGroupItem>
          <ToggleGroupItem
            value="list"
            aria-label="Toggle italic"
            className={cn(
              "hover:text-black-950 flex cursor-pointer flex-row gap-1 !rounded-[4px] px-1.5 py-[2px] transition-all duration-200 hover:bg-white",
              view === "list" && "text-black-950 bg-white",
            )}
            onClick={() => setView?.("list")}
          >
            <div className="flex flex-row items-center gap-1">
              <i className="ri-list-unordered text-md leading-none font-light"></i>
              <h1 className="text-md font-medium">List</h1>{" "}
            </div>
          </ToggleGroupItem>
        </ToggleGroup>
      )}
      <div className="relative w-[400px]">
        <i className="ri-search-line absolute top-1/2 left-4 -translate-y-1/2 text-lg text-white"></i>
        <Input
          type="text"
          variant="search"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="bg-black-950 h-[45px] w-full pr-4 pl-12 text-sm leading-normal font-medium text-white placeholder:text-white/50"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute top-1/2 right-4 -translate-y-1/2 text-white/50 transition-colors hover:text-white"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        )}
      </div>
    </div>
  );
}
